var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnackwarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.113,
    height: 18.973,
    viewBox: "0 0 21.113 18.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_284",
    "data-name": "Exclusion 284",
    d: "M23029.551,20813h-17.105a2,2,0,0,1-1.738-2.994l8.555-14.971a2,2,0,0,1,3.473,0l8.555,14.971a2,2,0,0,1-1.738,2.994Zm-8.551-5a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,23021,20808Zm-1.5-10v8h3v-8h-3Z",
    transform: "translate(-23010.443 -20794.029)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackwarning);
export default __webpack_public_path__ + "static/media/Snackwarning.3a94a286ec0c68fc46f0e53346aa436e.svg";
export { ForwardRef as ReactComponent };